export const date_to_datetime_local = (date: Date) => {
  const d = new Date(date);

  const p = (num: number) => num.toString().padStart(2, '0');

  const year = d.getFullYear();
  const month = p(d.getMonth() + 1);
  const day = p(d.getDate());
  const hours = p(d.getHours());
  const minutes = p(d.getMinutes());

  return `${year}-${month}-${day}T${hours}:${minutes}`;
};
